export const INVENTORY_STATUSES = ["match", "differs", "missingInCin7", "missingAt3pl", "cin7Only", "threePlOnly"] as const;
export type InventoryStatus = (typeof INVENTORY_STATUSES)[number];

export interface InventoryLevel {
  /** CIN7 (the source of truth) | ESTORE | TOLL */
  system: string;
  onHand: number | null;
  available: number | null;
  allocated: number | null;
  onOrder: number | null;
  inTransit: number | null;
  asOf: string;
  syncedAt: string;
}

/** A product at a location: every system's level and the reconciliation status. */
export interface Inventory {
  id: string;
  status: InventoryStatus | null;
  sku: string;
  productName: string | null;
  locationId: string;
  locationName: string;
  levels: InventoryLevel[];
}

export interface InventorySync {
  system: string;
  syncedAt: string;
  asOf: string;
  levels: number;
}

export interface InventoryLocationCount {
  id: string;
  name: string;
  count: number;
}

/** One page of the inventory (GET /inventory-levels), with the totals that come with every page. */
export interface InventoryList {
  inventory: Inventory[];
  /** Rows matching the filter across all pages. */
  total: number;
  statusCounts: { status: InventoryStatus | null; count: number }[];
  /** Every location in the inventory (the filter's options). */
  locations: InventoryLocationCount[];
  syncs: InventorySync[];
}
